import lazyWithReload from 'config/ChunkReload';
import { menuBuilder } from 'services/Routes.service';
import { SimulationIcon } from '@edusynch/edusynch-svg-icons';

const BaseList = lazyWithReload(() =>
  import(
    'modules/Simulation/SimulationsBase/SimulationsBaseList/SimulationsBaseList.container'
  )
);

const CustomtList = lazyWithReload(() =>
  import(
    'modules/Simulation/SimulationsCustom/SimulationsCustomList/SimulationsCustomList.container'
  )
);

const SimulationsMenu = menuBuilder([
  {
    Icon: SimulationIcon,
    name: 'Simulations',
    section: 'menu',
  },
]).addSubmenu([
  {
    name: 'Base List',
    path: '/base-simulations/base-list',
    exact: true,
    component: BaseList,
    ability: 'content_simulations',
  },
  {
    name: 'Custom List',
    path: '/custom-simulations/custom-list',
    exact: true,
    component: CustomtList,
    ability: 'content_simulations',
  },
]);

export default SimulationsMenu;
